import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchBulkUploadJobs = async (searchQuery) => {
  const { data } = await apiClient.get('/bulk-uploads', {
    params: searchQuery,
  });

  return data;
};

export const useGetBulkUploadsHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();

  const [bulkUploads, setBulkUploads] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['bulk_uploads', searchQuery],
    queryFn: () => fetchBulkUploadJobs(searchQuery),
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (fetchedData) {
      setBulkUploads(fetchedData.content ?? []);
      setTotalDocuments(fetchedData.total_elements ?? 0);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (!isError) {
      return;
    }

    if (error instanceof AxiosError) {
      if (error.response?.status) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message ?? error.message,
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: error.message,
            severity: 'error',
          }),
        );
      }
    } else {
      dispatch(
        showSnackbar({
          message: JSON.stringify(error),
          severity: 'error',
        }),
      );
    }
  }, [dispatch, error, isError]);

  return {
    bulkUploads,
    totalDocuments,
    isLoading,
  };
};
